/**
 * System API Service
 * Handles system identity and branding settings
 */
import axios from 'axios';

const BASE_URL = process.env.VUE_APP_BE_APP_BASE_URL || 'http://localhost:2121';

/**
 * Get current system identity
 * @returns {Promise<Object>}
 */
export async function getSystemIdentity() {
    const response = await axios.get(`${BASE_URL}/api/system/identity`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
    });
    return response.data;
}

/**
 * Update system identity
 * @param {FormData} formData 
 * @returns {Promise<Object>}
 */
export async function updateSystemIdentity(formData) {
    const response = await axios.post(`${BASE_URL}/api/system/identity`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
        }
    });
    return response.data;
}
